<template>
  <div v-click-outside-textInput="closePopup" class="relative w-full">
    <!-- Label and character count -->
    <p class="flex justify-between mb-1">
      <span>{{ lableText }}</span>
      <span v-if="showcharLimit" class="text-xs text-gray-500">{{ inputValue.length }}/{{ textMaxlength }}</span>
    </p>

    <!-- Textarea wrapper -->
    <div class="relative w-full">
      <textarea
        :maxlength="textMaxlength"
        v-model="inputValue"
        :id="inputId"
        :ref="inputId"
        :rows="rows || 1"
        :cols="cols"
        :disabled="disabled"
        :readonly="setReadOnly"
        :pattern="pattern"
        autocomplete="off"
        :autofocus="setAutoFocust"
        :class="['floating-textarea', borderClass, { 'border-error': showError }]"
        @input="handleInput"
        @focus="focusInput"
        @blur="blurInput"
        @click="onClickInputAction"
        @keypress="keyPressAction"
        @keypress.enter="enterkeyPressAction"
        @change="change"
        @keyup="keyup"
      ></textarea>

      <!-- Floating label -->
      <label
        :for="inputId"
        class="floating-label"
        :class="{ 'floating-label-active': inputValue || isFocused }"
      >
        {{ placholderText }}
      </label>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

Vue.directive('click-outside-textInput', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});

export default {
  props: [
    'cols', 'rows', 'pattern', 'textRight', 'inputext', 'textMaxlength', 
    'lableText', 'inputId', 'autoFocus', 'fieldError', 'setReadOnly', 
    'placholderText', 'inputType', 'disabled', 'borderType', 'showcharLimit'
  ],
  data() {
    return {
      inputValue: '',
      showError: false,
      isFocused: false,
      setAutoFocust: false
    };
  },
  computed: {
    borderClass() {
      if (this.borderType === 'bottom') {
        return 'border border-gray-300 focus:border-primary focus:ring-0';
      }
      return 'border border-gray-300 rounded focus:border-primary focus:ring-1 focus:ring-primary';
    }
  },
  watch: {
    fieldError(val) {
      this.showError = val;
    },
    inputext(val) {
      this.inputValue = val || '';
      this.$nextTick(() => this.autoResize());
    }
  },
  mounted() {
    if (this.inputext) {
      this.inputValue = this.inputext;
      this.$nextTick(() => this.autoResize());
    }
    if (this.autoFocus) {
      this.$nextTick(() => {
        document.getElementById(this.inputId)?.focus();
      });
    }
  },
  methods: {
    handleInput(event) {
      this.inputValue = event.target.value;
      this.autoResize();
      this.$emit('inputChangeAction', this.inputValue);
    },
    autoResize() {
      const textarea = this.$refs[this.inputId];
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
      }
    },
    focusInput() { this.isFocused = true; this.$emit('focus'); },
    blurInput() { this.isFocused = false; this.$emit('blurAction'); },
    onClickInputAction() {
      document.getElementById(this.inputId)?.focus();
      this.$emit('onClickInputAction');
    },
    change() { this.$emit('change'); },
    keyPressAction() { this.$emit('keyPressAction'); },
    enterkeyPressAction() { this.$emit('enterkeyPressAction'); },
    keyup() { this.$emit('keyup'); },
    closePopup() { this.$emit('closePopup'); }
  }
};
</script>

<style>
.floating-textarea {
  width: 100%;
  padding: 12px 12px;
  font-size: 16px;
  resize: none;
  overflow: hidden;
  outline: none;
  background: white;
  transition: border-color 0.2s;
}

.floating-textarea:focus {
  border-color: #1295BA;
}

.floating-label {
  position: absolute;
  left: 12px;
  top: 15px;
  font-size: 16px;
  color: #9ca3af;
  pointer-events: none;
  transition: all 0.2s ease;
  background: white;
}

.floating-label-active {
  top: -6px;
  left: 8px;
  font-size: 12px;
  color: #1295BA;
  padding: 0 4px;
}

.border-error {
  border-color: #ef4444 !important;
}
</style>
